import React from 'react';
import styled from 'styled-components';
import Table from 'rc-table';
import { ColumnType, ColumnGroupType, DefaultRecordType } from 'rc-table/lib/interface';

const TableContainer = styled(Table)`
  font-size: 14px;
  font-weight: normal;
  & table {
    margin: 0 auto;
    width: 100%; 
    border-spacing: 0;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  }
  & th {
    padding: 8px 16px;
    border-bottom: 1px solid #ccc;
    text-align: left;
  }
  & tr {
    &.disabled {
      pointer-events: none;
    }
    &:hover td {
      ${v => v.onRow && `
        cursor: pointer;
        background-color: rgba(51, 153, 204, 0.1);
    `}
    }
  }
  & td {
    padding: 8px 16px;
    border-bottom: 1px solid #ccc;
    &.right {
      text-align: right;
    }
    &.center {
      text-align: center;
    }
  }
  & tr:last-child {
    & td {
      border-bottom: none;
    }
  }
`

interface TableBoxProps<T> {
  rowKey: string;
  scroll: {
    x?: number | true | string;
    y?: number | string;
  };
  columns: readonly (ColumnGroupType<DefaultRecordType> | ColumnType<DefaultRecordType>)[];
  data: T[];
}

type Table = <T>(
  props: TableBoxProps<T>
) => React.ReactElement<TableBoxProps<T>>;

const TableBox: Table = (props) => {
  return (
    <TableContainer
     {...props}
    />
  )
}
export default TableBox;